import storage from '@/core/store/storage';

export function getAccessToken() {
  const ngStorage = storage.getItem('ngStorage-credentials');
  if (!ngStorage) return null;
  try {
    return JSON.parse(ngStorage)?.access_token || null;
  } catch (error) {
    return null;
  }
}

export function clearAccessToken() {
  return storage.removeItem('ngStorage-credentials');
}

export function getStudioPassword() {
  const ngStorage = storage.getItem('ngStorage-storedStudioPassword');
  if (!ngStorage) return null;
  try {
    return JSON.parse(ngStorage) || null;
  } catch (error) {
    return null;
  }
}

export function clearStudioPassword() {
  return storage.removeItem('ngStorage-storedStudioPassword');
}
